/**
 * RM-359 (the product agent, reviewed by Kapil, 10/30): the Notes / Special
 * Requests guidance on a regular request (never group/private dining). What
 * can help the member get the table, then seating, kept apart. The same words
 * RM AI and RM via Text send (the replies table's `request.notes.ask`, which
 * a server test pins this to). The wording is approved: keep it exactly.
 */
export const NOTES_GUIDANCE = Object.freeze({
  title: 'Notes/Special Requests? Please note - this is what can help you get the table:',
  items: Object.freeze([
    'State the premium bottle of wine or other item you’ll be ordering',
    'If you’re truly friends with a senior partner of the restaurant/group, add that',
    'If you’re hosting a VIP (Artist, Athlete), share the name(s)',
  ]),
  seating: 'Want specific seating? State it but may be harder to accommodate',
  // Kapil 10/30: item 1 ends with the restaurant's site, when it has one (`request.notes.reviewLink`)
  reviewHere: ' - review here:',
})

/**
 * The restaurant's website as a link: { href, label } ("naiachicago.com" →
 * https://naiachicago.com, shown as naiachicago.com), or null without one.
 */
export function menuSite(website) {
  const raw = String(website || '').trim()
  if (!raw || /\s/.test(raw)) return null
  const href = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`

  return { href, label: href.replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/+$/, '') }
}

/** Only a regular request carries it (a group/private dining inquiry has its own optional details). */
export function showsNotesGuidance(reservation) {
  return !reservation?.reservationType || reservation.reservationType === 'general'
}
